import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useDbtCloudAccount } from '@/context/DbtCloudProvider';
import { truthy } from '@/util/array';
import { sanitizeCoreFilePath } from '@/util/file';
import { useIsExternal } from '../dbtStrategy/usePackage';
import { useLinkToDbtCloud } from '../links';

export const useIdeHandoff = ({
  files,
  packageName,
  exposureUrl,
  projectId,
}: {
  files: (string | null | undefined)[];
  packageName: string | null | undefined;
  exposureUrl?: string | null;
  projectId?: number;
}) => {
  const { accountId = 0 } = useDbtCloudAccount();
  const { projectId: inheritedProjectId } = useDbtCloudProject();
  const validProjectId = projectId ?? inheritedProjectId ?? 0;
  const getCloudIdeLink = useLinkToDbtCloud('cloudIde');
  const {
    isExternal: isImported,
    coreProjectName,
    fetching,
  } = useIsExternal(packageName, validProjectId);

  const isExternal = !!(packageName && isImported);
  const disableIdeLink = !files.length || isExternal;
  const showIdeLink = !!getCloudIdeLink && !exposureUrl;

  const ideLink =
    disableIdeLink || !showIdeLink
      ? ''
      : getCloudIdeLink({
          accountId,
          projectId: validProjectId,
          file: files
            .map((file) => sanitizeCoreFilePath(file, coreProjectName))
            .filter(truthy),
        });

  return {
    determiningIdeAccess: fetching,
    showIdeLink,
    disableIdeLink,
    ideLink,
  };
};
